<style scoped>
body {
  overflow: hidden;
  min-height: 100vh !important;
}
.btn-primary {
  background-color: #1a3665 !important;
}
.btn-outline-primary {
  border: 1.5px solid #1a3665 !important;
  color: #1a3665 !important;
}
.btn-outline-primary:hover {
  background-color: #1a3665 !important;
  color: white !important;
}
.bg-login-half {
  background-image: url("/img/bg-login.jpg");
  background-size: cover;
}
:root {
  --input-padding-x: 1.5rem;
  --input-padding-y: 0.75rem;
}

.login,
.image {
  min-height: 100vh;
}

.bg-image {
  background-image: url("/img/bg-login.jpg");
  background-size: cover;
  background-position: center;
}

.login-heading {
  font-weight: 300;
}

/* Fallback for Edge
-------------------------------------------------- */

@supports (-ms-ime-align: auto) {
  .form-label-group > label {
    display: none;
  }
  .form-label-group input::-ms-input-placeholder {
    color: #777;
  }
}
</style>
<template>  
  <div class="container-fluid bg-white">
    <div class="row no-gutter justify-content-center">
      <div class="col-md-8 col-lg-5">
        <div class="login d-flex align-items-center py-5">
          <div class="container">
            <div class="row">
              <div class="col-md-9 col-lg-8 mx-auto">
                <div class="text-center">
                  <h3 class="text-muted font-weight-bold">Buat Password Baru</h3>
                  <p class="text-muted col-9 mx-auto">
                    Anda hanya perlu membuat password baru untuk
                    akses ke Back Office
                  </p>
                </div>
                <form name="form" v-on:submit.prevent="postResetPassword" action="#" class="my-xl-5 m-md-3">
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control p-4"
                      placeholder="Masukkan Email"
                      required
                      v-model="formData.email"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="password"
                      class="form-control p-4"
                      placeholder="Masukkan Password Baru"
                      required
                      v-model="formData.password"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="Password"
                      class="form-control p-4"
                      placeholder="Konfirmasi Password"
                      required
                      v-model="formData.konfirmasiPassword"
                    />
                  </div>
                  <CButton
                    type="submit"
                    color="primary"
                    size="lg"
                    block="true"
                    class="py-2 mt-4 font-weight-bold"
                  >Kirim</CButton>
                  <router-link to="/pages/login" class="nav-link mt-4 text-center">
                    <p class="font-weight-bold color-primary">Kembali ke Halaman Login</p>
                  </router-link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none col-md-4 col-lg-7 bg-image d-sm-none d-lg-block d-xl-block d-md-none">
        <div class="d-md-flex align-items-center h-100 text-center justify-content-center ml-auto">
          <div class="col-12 d-flex align-items-center h-100 text-white">
            <div class="ml-auto">
              <p class="h1 display-4 font-weight-normal text-right">Selamat Datang di</p>
              <p class="h1 display-4 font-weight-normal text-right">Back Office</p>
              <h5 class="text-right font-weight-bold">Institut Akuntan Publik Indonesia</h5>
              <p class="h4 font-weight-normal mt-3 text-right">Silakan Membuat Passowrd Baru.</p>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ResetPasswordService from "../../services/auth/reset-password.service";
import baseUrl from "../../services/base-url"

export default {
  data() {
    return {
      formData: {
        email: "",
        kodeOtp: this.$route.params.kode_otp,
        konfirmasiPassword: "",
        password: ""
      }
    };
    true
  },
  mounted() {
    // if (this.$route.params.kodeOtp === undefined) {
    //   this.$router.push("/pages/verifikasi");
    // }
  },
  methods: {
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Email atau password tidak sesuai!",
        icon: "error",
        showCancelButton: false
      });
    },
    alertSuccess() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-start",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Password berhasil diubah!"
      });
    },
    postResetPassword() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      ResetPasswordService.postResetPassword(this.formData)
        .then(response => {
          loader.hide();
          // comment console console.log(response);
          this.alertSuccess();          
          this.$router.push("/pages/login/");
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError();
        });
    }
  }
};
</script>